module.exports = __webpack_public_path__ + "img/userlogo.7b1414f3.png";